import React from 'react';
import autobind from 'autobind-decorator';
import useLocalStorage from 'hooks/useLocalStorage';
import { timeUtils } from 'utils/timeUtil';
import { action, observable, runInAction } from 'mobx';

@autobind
class AbstractScoreCommon {
  localstorage = new useLocalStorage();

  @observable
  selectedGames = [];

  constructor() {
    const today = timeUtils.todayYmd();

    this.localstorage.getAsyncArrItem('favoriteGames').then((success) => {
      if (!!success) {
        if (success.length > 0) {
          const deleteFavorite = success.filter((item) => {
            const checkDate = item.date.split('T')[0];
            const differDay = timeUtils.checkDifferenceToday(checkDate, today);

            return Math.abs(differDay) < 2;
          });

          if (deleteFavorite.length !== success.length) {
            this.localstorage.setItem(
              'favoriteGames',
              JSON.stringify(deleteFavorite)
            );
            this.selectedGames = deleteFavorite;
          } else {
            this.selectedGames = success;
          }
        }
      } else {
        this.selectedGames = [];
      }
    });
  }

  @action
  setSelectedGame(isSelected, id, originStartDateTime, gameStatus, sportsType) {
    const { addKeyData, getAsyncArrItem, removeKeyArr } = this.localstorage;

    // debugger;

    if (isSelected) {
      removeKeyArr('favoriteGames', 'key', id);
    } else {
      addKeyData('favoriteGames', [
        {
          type: 'gameId',
          key: id,
          date: originStartDateTime,
          sportsType:
            sportsType.toLowerCase() === 'icehockey'
              ? 'hockey'
              : sportsType.toLowerCase(),
          gameStatus
        }
      ]);
    }
    getAsyncArrItem('favoriteGames').then((success) => {
      runInAction(() => {
        this.selectedGames = success;
      });
    });
  }

  @action
  getFavoriteGames() {
    const today = timeUtils.todayYmd();

    this.localstorage.getAsyncArrItem('favoriteGames').then((success) => {
      if (!!success) {
        if (success.length > 0) {
          const deleteFavorite = success.filter((item) => {
            const checkDate = item.date.split('T')[0];
            const differDay = timeUtils.checkDifferenceToday(checkDate, today);

            return Math.abs(differDay) < 2;
          });

          if (deleteFavorite.length !== success.length) {
            this.localstorage.setItem(
              'favoriteGames',
              JSON.stringify(deleteFavorite)
            );
            this.selectedGames = deleteFavorite;
          } else {
            this.selectedGames = success;
          }
        } else {
          this.selectedGames = [];
        }
      } else {
        this.selectedGames = [];
      }
    });
  }
}

export default AbstractScoreCommon;
